export default __webpack_public_path__ + "static/media/list.bcc81cd2.svg";